import React from "react"
import "./FormField.css"

import DatePicker from "react-datepicker"

// component for form fields
// any props (other than label, icon, className and children) will be applied to the input element. this way you can specify the input type, event listeners, etc
// label prop will be used for the label html element
// icon prop (if there is one) should be the name of the icon without the mdi- prefix
// className prop will be added to the form-field container div

function FormDatePicker2(props) {
  const {
    id,
    minDate,
    maxDate,
    className,
    label,
    header,
    icon,
    maxWidth,
    noMargin,
    ...datePickerProps
  } = props
  return (
    <div
      className={
        "form-datepicker" +
        (className ? " " + className : "") +
        (maxWidth ? " form-datepicker-max-width" : "") +
        (noMargin ? " mb-1" : " mb-3")
      }
    >
      {label ? <label htmlFor={id}>{label}</label> : null}
      {header}
      <div className="form-datepicker">
        {icon ? <i className={"form-icon mdi mdi-" + icon}></i> : ""}
        <DatePicker
          id={id}
          className="form-datepicker-style"
          minDate={minDate}
          maxDate={maxDate}
          popperModifiers={{
            preventOverflow: {
              enabled: true
            }
          }}
          {...datePickerProps}
        />
      </div>
    </div>
  )
}

export default FormDatePicker2
